import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import preset from './default-preset/preset'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

Vue.use(Vuetify)

export default new Vuetify({
  preset,
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    options: {
      customProperties: true,
      variations: false,
    },
    themes: {
      light: {
        morning:   '#fb8c00', // orange darken-2
        afternoon: '#1e88e5', // blue   darken-1
        evening:   '#8e24aa', // purple darken-2
      },
      dark: {
        morning:   '#fb8c00', // orange darken-2
        afternoon: '#1e88e5', // blue   darken-1
        evening:   '#8e24aa', // purple darken-2
      },
    },
  },
})
